import Swiper, { Autoplay, Navigation } from 'swiper';
import { swiperObserver } from '../utils/swiper.utils.js';

let exploreHubSwiperWr = document.querySelectorAll('.explore-hub-swiper-wr');

exploreHubSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    let wrapper = swiperEl.querySelector('.swiper-wrapper');

    let swiper = new Swiper(swiperEl, {
      modules: [Autoplay, Navigation],
      observer: true, //needs to calculate swiper size
      observeParents: true, //needs to calculate swiper size
      spaceBetween: 12,
      slidesPerView: 1,
      breakpoints: {
        480: {
          spaceBetween: 14,
          slidesPerView: 1.3,
        },
        740: {
          spaceBetween: 14,
          slidesPerView: 2,
        },
        1024: {
          spaceBetween: 19,
          slidesPerView: 3,
        },
      },
      autoplay: {
        delay: 400000,
        disableOnInteraction: false,
        pauseOnMouseEnter: window.innerWidth >= 640,
      },
      navigation: {
        prevEl: prevEl,
        nextEl: nextEl,
      },
    });

    swiperObserver(swiper);
  }
});